import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    dateRoot: {
      border: `1px solid ${theme.palette.border.primary}`,
      padding: "10px 14px",
      borderRadius: "8px",
      width: "512px",
      background: theme.palette.background.primary,
      "& .MuiInputAdornment-positionEnd": {
        "& button": {
          padding: "0 !important",
          marginInlineEnd: "8px",
        }
      },
      "& .MuiInputBase-root": {
        flexDirection: "row-reverse",
      },
      "& .MuiInputBase-input": {
        padding: "0 !important",
        lineHeight: "24px",
        height: "24px",
        color: theme.palette.text.primary,
        fontSize: "16px",
        "&::placeholder": {
          opacity: "1 !important",
          lineHeight: "24px",
          fontSize: "16px",
          fontWeight: 400,
          color: theme.palette.text.placeholder,
        },
      },
      datePickerDialog: {
        "& .MuiPickersCalendarHeader-root": {
        },
        "& .MuiPickersCalendarHeader-switchHeader": {
        },
      },
    },
  }
});
